import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { __decorate } from "tslib";
import { QuizQuestionType } from "@/models/quiz.model";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizQuestionLabel from "@/components/quiz/QuizQuestionLabel.vue";
import { isEqual } from 'lodash';
import QuizQuestionCorrectionExplanation from "@/components/questions/QuizQuestionCorrectionExplanation.vue";
import QuizAnswersValidationAlert from "@/components/quiz/QuizAnswersValidationAlert.vue";
let QuizCheckableTextQuestion = class QuizCheckableTextQuestion extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", void 0);
    _defineProperty(this, "questionCustomLabel", '');
    _defineProperty(this, "displayOverallVerdictIcon", false);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "displayAnswersValidationAlert", void 0);
    _defineProperty(this, "answersValidationState", void 0);
    _defineProperty(this, "selected", void 0);
    _defineProperty(this, "rightAnswer", null);
    _defineProperty(this, "checkType", 'checkbox');
  }
  mounted() {
    this.checkType = this.question.type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE ? 'checkbox' : 'radio';
  }
  emitSelectionChange(selected) {
    return selected;
  }
  get overallAnswersVerdictIcon() {
    return this.allAnswersAreCorrect ? 'check-circle-outline' : 'close-circle-outline';
  }
  get allAnswersAreCorrect() {
    if (this.checkType === "checkbox" && Array.isArray(this.selected) && Array.isArray(this.rightAnswer)) {
      return isEqual([...this.selected].sort(), [...this.rightAnswer].sort());
    } else if (this.checkType === "radio" && typeof this.selected === "number" && typeof this.rightAnswer === "number") {
      return this.selected === this.rightAnswer;
    }
    return false;
  }
  isSelected(answerId) {
    if (this.checkType === "checkbox" && Array.isArray(this.selected)) {
      return this.selected.includes(answerId);
    } else if (this.checkType === "radio" && typeof this.selected === "number") {
      return this.selected === answerId;
    }
    return false;
  }
  rightAnswersDefined() {
    return typeof this.rightAnswer === "number" && !!this.rightAnswer || Array.isArray(this.rightAnswer) && !!this.rightAnswer.length;
  }
  isRightAnswer(answerId) {
    if (!this.rightAnswersDefined()) {
      return false;
    }
    if (this.checkType === "checkbox" && Array.isArray(this.rightAnswer)) {
      return this.rightAnswer.includes(answerId);
    } else if (this.checkType === "radio" && typeof this.rightAnswer === "number") {
      return this.rightAnswer === answerId;
    }
    return false;
  }
  isBadAnswer(answerId) {
    if (!this.rightAnswersDefined()) {
      return false;
    }
    return this.isSelected(answerId) && !this.isRightAnswer(answerId);
  }
  onInputChange(event, answerId) {
    if (this.checkType === "checkbox") {
      const checked = event.target.checked;
      let newSelected = Array.isArray(this.selected) ? [...this.selected] : [];
      if (checked) {
        if (!newSelected.includes(answerId)) newSelected.push(answerId);
      } else {
        newSelected = newSelected.filter(id => id !== answerId);
      }
      this.emitSelectionChange(newSelected);
    } else {
      this.emitSelectionChange(answerId);
    }
  }
};
__decorate([Prop({
  required: true
})], QuizCheckableTextQuestion.prototype, "question", void 0);
__decorate([Prop], QuizCheckableTextQuestion.prototype, "questionCustomLabel", void 0);
__decorate([Prop], QuizCheckableTextQuestion.prototype, "displayOverallVerdictIcon", void 0);
__decorate([Prop({
  default: false
})], QuizCheckableTextQuestion.prototype, "isResultMode", void 0);
__decorate([Prop({
  default: false
})], QuizCheckableTextQuestion.prototype, "displayAnswersValidationAlert", void 0);
__decorate([Prop({
  default: null
})], QuizCheckableTextQuestion.prototype, "answersValidationState", void 0);
__decorate([Prop({
  required: true
})], QuizCheckableTextQuestion.prototype, "selected", void 0);
__decorate([Prop], QuizCheckableTextQuestion.prototype, "rightAnswer", void 0);
__decorate([Emit("selectionChange")], QuizCheckableTextQuestion.prototype, "emitSelectionChange", null);
QuizCheckableTextQuestion = __decorate([Component({
  components: {
    QuizAnswersValidationAlert,
    QuizAnswerValidationAlert: QuizAnswersValidationAlert,
    QuizQuestionCorrectionExplanation,
    QuizQuestionLabel,
    WInput
  }
})], QuizCheckableTextQuestion);
export default QuizCheckableTextQuestion;